













import Vue from 'vue'
import Vuex from 'vuex'
export default Vue.component('character', {
  props: {
    character: Object,
    index: Number
  },
  computed: Vuex.mapState({
    characterStyles: function () {
      return {
        top: this.em(200 + this.additionalTopOffset),
        right: this.em(100 + (this.calculatedIndex * 220)),
        zIndex: `${this.character.isAtTelevision ? 100 : 1}`
      }
    },
    headStyles: function () {
      return {
        top: this.em(this.character.headTopOffset),
        left: this.em(this.character.headLeftOffset)
      }
    },
    calculatedIndex: function() {
      if(this.character.isAtWindow) {
        return 4
      } 
      if(this.character.isAtTelevision) {
        return 2
      }
      else {
        return this.index
      }
    },
    additionalTopOffset: function() {
      return this.character.isAtTelevision ? 115 : 0
    }
  }),
  methods: {
    em: function(pixels: number): string {
      return `${pixels / 16}em`
    }
  }
})
